import SettingQueueTaskTemplateTypeEnum from '../../../../../../projects/groups/data/enums/SettingQueueTaskTemplateTypeEnum';

/**
 * * Модель запроса на обновление шаблонов
 */
export default class UpsertTemplateRequest  {
	/**
	 * * Номер шаблона
	 */
	TemplateId?: string;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Шаблон в виде json
	 */
	Data!: string;
	/**
	 * * Тип шаблона
	 */
	Type!: SettingQueueTaskTemplateTypeEnum;
	constructor(obj?: Partial<UpsertTemplateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
